import { defineComponent as _defineComponent } from 'vue'
import { ModuleEventsIndicatorData } from '@/models/Charts/chartsData';
import ProgressBar from '@/components/careConsole/ProgressBar.vue';
import { EventColor } from '@/utils/color';
import { formatPercentage } from '@/utils/number';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModuleEventsIndicator',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data: ModuleEventsIndicatorData;
};



function percentage(value: number, total: number): number {
  if (total === 0) {
    return 0;
  }

  return (value / total) * 100;
}

const errorsPercentage = computed<number>(() =>
  percentage(props.data.errors, props.data.totalErrors),
);

const warningsPercentage = computed<number>(() =>
  percentage(props.data.warnings, props.data.totalWarnings),
);

return { __sfc: true,props, percentage, errorsPercentage, warningsPercentage, ProgressBar, EventColor, formatPercentage }
}

})